import { render, staticRenderFns } from "./SupplierDebtReport.vue?vue&type=template&id=5aaa8d24&scoped=true"
import script from "./SupplierDebtReport.vue?vue&type=script&lang=js"
export * from "./SupplierDebtReport.vue?vue&type=script&lang=js"
import style0 from "./SupplierDebtReport.vue?vue&type=style&index=0&id=5aaa8d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa8d24",
  null
  
)

export default component.exports